import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../config/api';
import './Admin.css';

const Admin = ({ user }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user && user.role === 'admin') {
      fetchDashboardData();
    }
  }, [user]);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/admin/dashboard`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDashboardData(response.data);
    } catch (error) {
      setError('Failed to load dashboard data');
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-page">
        <div className="container">
          <div className="alert alert-danger">
            {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="container">
        <div className="admin-header">
          <h1>Admin Dashboard</h1>
          <p>Manage the Dive-in Panels platform</p>
        </div>

        {dashboardData && (
          <>
            <div className="admin-stats">
              <div className="stat-card">
                <div className="stat-number">{dashboardData.statistics.totalUsers}</div>
                <div className="stat-label">Total Users</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{dashboardData.statistics.totalRespondents}</div>
                <div className="stat-label">Respondents</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{dashboardData.statistics.totalClients}</div>
                <div className="stat-label">Clients</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{dashboardData.statistics.totalProjects}</div>
                <div className="stat-label">Projects</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{dashboardData.statistics.activeProjects}</div>
                <div className="stat-label">Active Projects</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{dashboardData.statistics.totalRewards}</div>
                <div className="stat-label">Rewards</div>
              </div>
            </div>

            <div className="admin-sections">
              <div className="admin-section">
                <h2>Quick Actions</h2>
                <div className="action-grid">
                  <Link to="/admin/users" className="action-card">
                    <div className="action-icon">👥</div>
                    <h3>Manage Users</h3>
                    <p>View and manage user accounts</p>
                  </Link>
                  <Link to="/admin/projects" className="action-card">
                    <div className="action-icon">📊</div>
                    <h3>Manage Projects</h3>
                    <p>View and manage survey projects</p>
                  </Link>
                  <Link to="/admin/rewards" className="action-card">
                    <div className="action-icon">🎁</div>
                    <h3>Manage Rewards</h3>
                    <p>Add and manage reward catalog</p>
                  </Link>
                  <Link to="/admin/countries" className="action-card">
                    <div className="action-icon">🌍</div>
                    <h3>Manage Countries</h3>
                    <p>Add and manage countries</p>
                  </Link>
                </div>
              </div>

              <div className="admin-section">
                <h2>Recent Activity</h2>
                <div className="activity-list">
                  {dashboardData.recentTransactions.length > 0 ? (
                    dashboardData.recentTransactions.slice(0, 10).map((transaction, index) => (
                      <div key={index} className="activity-item">
                        <div className="activity-icon">
                          {transaction.type === 'earned' ? '💰' : '🎁'}
                        </div>
                        <div className="activity-content">
                          <p className="activity-description">{transaction.description}</p>
                          <p className="activity-user">{transaction.user?.name || 'Unknown User'}</p>
                        </div>
                        <div className="activity-amount">
                          {transaction.type === 'earned' ? '+' : '-'}{transaction.amount} USD
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="empty-state">
                      <p>No recent activity</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="admin-section">
                <h2>Users by Country</h2>
                <div className="country-stats">
                  {dashboardData.usersByCountry.length > 0 ? (
                    dashboardData.usersByCountry.map((country, index) => (
                      <div key={index} className="country-stat">
                        <span className="country-name">{country._id}</span>
                        <span className="country-count">{country.count}</span>
                      </div>
                    ))
                  ) : (
                    <div className="empty-state">
                      <p>No user data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Admin;
